import Backbone from '@polleverywhere/backbone'
import _ from 'underscore'

function check (delay = this.pollingInterval) {
  if (delay > 0) {
    this.timeoutId = setTimeout(this.destroy.bind(this), delay)
  } else {
    return this.destroy()
  }
}

function resetTimeout () {
  clearTimeout(this.timeoutId)
  return delete this.timeoutId
}

/*
 * Out of band authentication code model. An out of band authentication code is
 * exchanged (consumed) for a session by a browser that cannot sign in to SSO
 * providers. For example, the embedded browser used in the presentation
 * applications cannot sign in via Google SSO. An out of band authentication
 * code can be created via the embedded browser which then opens an
 * authentication endpoint in another browser. The user's session in the
 * external browser can be associated with the out of band code and the accessed
 * in the embedded browser.
 *
 * @namespace Model
 *
 * @event completed Code has been used to create session
 *
 * @event failed Error fetching code status @param [XHR] xhr XHR Request
 *
 */
export default class OutOfBandAuthenticationCode extends Backbone.Model {
  get urlRoot () { return '/auth/out_of_band_authentication_codes' }

  get idAttribute () { return 'code' }

  /*
   * @param [Object] options
   * @param options [Number] pollingInterval - Set polling interval in milliseconds
   * @return [Object] The out of band authentication code instance
   *
   */
  initialize (options = {}) {
    _.defaults(options, {
      pollingInterval: 2000
    })

    const interval = parseInt(options.pollingInterval)

    if (isNaN(interval)) {
      throw new Error('`options.pollingInterval` must be a number.')
    } else {
      this.pollingInterval = interval
    }

    this.stopChecking()

    return this
  }

  /*
   * @return [Object] The out of band authentication code instance
   *
   */
  startChecking () {
    this.isPolling = true

    if (!this.timeoutId) {
      check.call(this, 0)
    }

    return this
  }

  /*
   * @return [Object] The out of band authentication code instance
   *
   */
  stopChecking () {
    this.isPolling = false
    return this
  }

  destroy () {
    if (this.isPolling) {
      return super.destroy({
        success: () => {
          this.stopChecking()
          this.trigger('completed')
        },
        error: (_model, xhr) => {
          if (xhr.status === 404) {
            return check.call(this)
          }
          resetTimeout.call(this)
          return this.trigger('failed', this, xhr)
        }
      })
    } else {
      return resetTimeout.call(this)
    }
  }
}
